var _style, _circle, _path, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOverview = function SvgOverview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "overview_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".overview_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 18.5,
    r: 5,
    className: "overview_svg__st0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7V3c-.9-.8-2.1-.8-3 0L6 7 4.5 8.5l-3 7",
    className: "overview_svg__st0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 5,
    className: "overview_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7V3.1c.9-.8 2.1-.8 3 0L18 7l1.5 1.5 3 7M8 11c0-1.1 1.8-2 4-2s4 .9 4 2M10.5 18.5V9.1M13.5 18.5V9.1",
    className: "overview_svg__st0"
  })));
};
export default SvgOverview;